var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinished2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.22,455.26s1.79-24.55-9-49.11S281,379.82,281,372.63s7.22-15.58,8.42-31.75.6-24,.6-24,25.75,40.72,43.72,43.12,28.75-14.37,22.16-37.13-35.34-41.32-46.71-56.3-37.14-15-50.31-15-19.76-4.79-22.16-13.77-2.39-27-2.39-27-15.58,9.58-41.93-1.2c0,0,2.4,32.94-.6,37.73S184.64,257,166.67,257s-32.94,3.6-41.32,12-43.12,41.92-52.1,55.1-4.2,27.55,6.58,32.94,21.56.59,29.35-6.59,32.34-29.95,32.34-29.95,0,13.78,6.59,33.54,12,17.37,7.18,31.74-14.37,18.57-17.36,37.13a176.46,176.46,0,0,0-2.4,32.34",
    className: "colorToChange",
    style: {
      fill: "#339F9A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.59,297.16c29.88,5.76,41.41-22.88,45.42-45.77-9.95-1.1-15.19-5.73-17.27-13.52-2.39-9-2.39-27-2.39-27s-15.58,9.58-41.93-1.2c0,0,2.4,32.94-.6,37.73-2.08,3.34-4.76,6.68-12.26,8.39C179.29,266.07,181.36,291.9,208.59,297.16Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.39,178.26s1,26.79,20.72,39.93,34.37,5.56,42.46-5.56,13.15-22.24,13.15-38.41,2-23.26-3.54-33.37-24.77-15.16-24.77-15.16A303.44,303.44,0,0,1,198.63,154C183.46,168.65,176.39,178.26,176.39,178.26Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.25,324.11s-10.78,12-10.78,24.55,7.18,24,27,41.92,38.32,31.14,46.11,35.34,15.57-1.2,15.57-1.2,12.88,12.87,14.37,9.88-4.49-7.49-5.69-9.28a24.6,24.6,0,0,0-3.59-3.89s6.29.89,8.69,3,6.28,5.69,8.08,5.39,1.8-1.8-.9-5.39a32.06,32.06,0,0,0-7.78-7.19c-1.8-1.19-7.79-4.49-7.79-4.49s8.68-.6,11.68,1.2,11.08,7.19,11.68,4.79.6-3.89-2.4-6.59-9-6-12.57-6.59a37.13,37.13,0,0,1-7.19-2.09s6.89-2.4,9.28-2.4,12,4.79,14.67,4.2,1.2-3-.89-4.5-11.38-5.09-15.28-5.39-25.75,7.19-28.44,7.19-9.58-9.58-16.77-22.46-9.88-32.94-25.15-39.82",
    className: "colorToChange",
    style: {
      fill: "#339F9A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.76,335.35c-2.5-5.71-.36-18.21,2.14-36.06s5-36.06,5-45.7,1.59-23-1.55-27.31-14.57-16-15.42-21.42,6.85-13.71,6.85-13.71,2.29-4.29,4.29-2,1.14,5.14,0,9.14-2.29,7.14-2.29,7.14,10,3.14,12.57,1.43,2.34-11.49,2.16-16.28c-.37-9.34-4.11-5.35-6.7-.93-1.25,2.12-8.57.86-4.29-4.57s8.26-10.22,12.26-5.93,6.85,12.57,6.85,12.57,2.86-13.61,5.46-21.61,7.26-11.17,8.94-10.61,1.49,3.35-.19,7.26-5.4,14.7-6.33,18.24-1.11,7.63.75,7.26,8.37-11.73,10.24-16.57,4.65-9.3,7.81-11.35,5.77.56,4.47,3.91A170.27,170.27,0,0,1,355,185.93a76.4,76.4,0,0,0-5.21,11.54,131.25,131.25,0,0,1,9.68-9.31c4.47-3.72,9.31-4.46,10.79-3.16s.19,1.49-3.53,4.47S357.45,196,353,203.24a68.36,68.36,0,0,0-8,17.12,58.05,58.05,0,0,1-5.4,11.36s3.49,28.34,9.54,43.93,16.75,38.39,13.49,54.68-9.54,24.66-18.38,27.22a17.09,17.09,0,0,1-15.12-2.79",
    className: "colorToChange",
    style: {
      fill: "#339F9A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448,127.31s-29.05-58.17-93.21-66.79-109,33.39-156.18,54.94c-24.72,11.28-53,6.9-79.21,12.36C35.45,145.28,3.83,254.68,38.79,316.89c30.27,53.86,83.53,81.86,164.65,88.33s138,14,210.65-38.78S481.88,203.79,448,127.31Z",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,127.31s-29.05-58.17-93.21-66.79-109,33.39-156.18,54.94c-24.72,11.28-53,6.9-79.21,12.36C35.45,145.28,3.83,254.68,38.79,316.89c30.27,53.86,83.53,81.86,164.65,88.33s138,14,210.65-38.78S481.88,203.79,448,127.31Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.78,383.65c3.46-19.89,36.32-57.94,26.81-81.29s-32.87,51-41.52,51.89-.86-33.73,11.25-66.59,21.62-67.46,0-80.43-20.76,89.94-25.95,86.48,3.46-46.7-2.59-73.51-19.89-5.19-19.89,26,9.51,48.43,2.59,51-28.15-7.1-27.67,26.81,26.81,74.38,17.29,69.19-26.81-25.08-23.35,6.92c2.45,22.62,20,44.36,30.1,55.17h46.24c7.05-7.25,20.75-22.53,30-40.47C471.1,389.71,431.32,403.55,434.78,383.65Z",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.56,453.27C370,441,366,426,362,412c-2-9-2-19,5-25,7-5,11,4,15,8,3-2,1-5,1-7a386.63,386.63,0,0,1-3-48c0-10,4-18,8-27,2-3,4-6,7-7s6,0,7,3c2,7,2,14,3,21,2-2,1-5,1-7,4-29,1-57,10-85,1-2,4-4,6-3,7,1,7,10,7,16,4,29-5,57-8,86,0,2-1,4,1,6,1-7,5-14,7-21,1-3,3-7,6-9,2-1,4,0,6,2,4,6,5,12,4,19-3,17-9,31-16,46l-3,9c-1,6-5,13-1,18,7-1,9-9,15-13s8,1,9,5c4,20-3,38-13.08,54.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.57,449.45s-2.33-46.73,3.51-89.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "387.3 419.66 406.57 440.69 423.51 426.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "401.31 367.1 406.57 393.96 421.76 367.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.66,
    y1: 353.08,
    x2: 414.16,
    y2: 327.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.87,
    y: 148.31,
    width: 62.98,
    height: 78.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.6,
    y: 148.31,
    width: 62.98,
    height: 78.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.87,
    y: 239.92,
    width: 62.98,
    height: 78.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.6,
    y: 239.92,
    width: 62.98,
    height: 78.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.87,
    y: 331.53,
    width: 62.98,
    height: 78.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.6,
    y: 331.53,
    width: 62.98,
    height: 78.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.44,66.72h0A70.14,70.14,0,0,0,72.3,136.86H212.58A70.14,70.14,0,0,0,142.44,66.72Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.15,104.32s0-15-25.75-12-36.54,25.75-44.32,30.54-22.16,9-22.76,16.17,6,10.18-.6,15.57S123,164.81,125.35,172s9,14.37,6,19.17-11.38,9.58-3.6,15,11.38,6.59,11.38,13.77-3,12,4.2,14.38,11.37-2.4,15.57,6.58,8.38,11.38,15.57,9.58,17.36-4.79,21-2.39,15,9,19.76,5.39,9-9,16.17-6,13.18,7.19,16.17,1.8,0-6.59,11.38-9,15.57-1.79,15.57-11.37-.6-12,4.79-16.17,10.18-2.4,8.39-12.58-5.39-12.58-3.6-22.76-3-13.77-6.59-16.77-7.78-8.38-6.58-13.77,10.18-6,1.19-15.57-13.17-6.59-15-13.78S249.32,94.74,233.15,104.32Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.16,122.35c-3.69,5.84-6.54,12.43-12.48,18-8.58,8-30.56,15-31.63,22.52s2.68,11.79-4.82,18.22-19.3,8-19.3,14.48,3.21,8.58,1.61,13.4",
    style: {
      fill: "none",
      stroke: "#616161",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.1,115.15s-2.68-7-10.19,0c-.58.54-1.13,1.1-1.65,1.67",
    style: {
      fill: "none",
      stroke: "#616161",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.54,145.79c-6.6,1.6-11.81,2.75-12.35,7.43-1.08,9.11.53,15-5.9,17.69s-15,7-12.33,12.33,3.21,7,2.68,9.11",
    style: {
      fill: "none",
      stroke: "#616161",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,106.57S210,96.93,202,105.5s-4.29,19.3-16.62,31.1a31.3,31.3,0,0,1-10.86,6.59",
    style: {
      fill: "none",
      stroke: "#616161",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.17,182.6a9.72,9.72,0,0,0,3.61,3.32",
    style: {
      fill: "none",
      stroke: "#616161",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.75,120s13.4-4.29,16.61,3.21,4.83,20.91,10.73,23.06,8.57,5.36,8.57,17.15a37.78,37.78,0,0,0,1.68,11.21",
    style: {
      fill: "none",
      stroke: "#616161",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,215.4c4.29-7,10.18-4.28,10.72-11.79s-3.75-9.65.53-14.47,11.26-7,11.26-7",
    style: {
      fill: "none",
      stroke: "#616161",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.79,230.42a25.35,25.35,0,0,1-5.1-5.73",
    style: {
      fill: "none",
      stroke: "#616161",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.22,455.26s1.79-24.55-9-49.11S281,379.82,281,372.63s7.22-15.58,8.42-31.75.6-24,.6-24,25.75,40.72,43.72,43.12,28.75-14.37,22.16-37.13-35.34-41.32-46.71-56.3-37.14-15-50.31-15-19.76-4.79-22.16-13.77-2.39-27-2.39-27-15.58,9.58-41.93-1.2c0,0,2.4,32.94-.6,37.73S184.64,257,166.67,257s-32.94,3.6-41.32,12-43.12,41.92-52.1,55.1-4.2,27.55,6.58,32.94,21.56.59,29.35-6.59,32.34-29.95,32.34-29.95,0,13.78,6.59,33.54,12,17.37,7.18,31.74-14.37,18.57-17.36,37.13a176.46,176.46,0,0,0-2.4,32.34",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.92,270.35c-.41,0-1.91,1,0,3.91C265.83,271.37,264.33,270.35,263.92,270.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.92,270.35c-.41,0-1.91,1,0,3.91C313.83,271.37,312.33,270.35,311.92,270.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M311.92,294.35c-.41,0-1.91,1,0,3.91C313.83,295.37,312.33,294.35,311.92,294.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.92,294.35c-.41,0-1.91,1,0,3.91C265.83,295.37,264.33,294.35,263.92,294.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M287.92,282.35c-.41,0-1.91,1,0,3.91C289.83,283.37,288.33,282.35,287.92,282.35Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.92,258.35c-.41,0-1.91,1,0,3.91C289.83,259.37,288.33,258.35,287.92,258.35Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M265,274.86c3.46.19,3.58-1.62,3.38-2S266.49,271.75,265,274.86Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M315.93,274.17l-1.33-1.37a4.75,4.75,0,0,0-1.64,2.06A4,4,0,0,0,315.93,274.17Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M289,286.86c3.46.19,3.58-1.62,3.38-2S290.49,283.75,289,286.86Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M289,262.86c3.46.19,3.58-1.62,3.38-2S290.49,259.75,289,262.86Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M307.5,272.89c-.2.35-.07,2.16,3.38,2C309.35,271.75,307.71,272.53,307.5,272.89Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M307.5,296.89a1.24,1.24,0,0,0,.52,1.37h0a4.2,4.2,0,0,0,2.86.6,5.57,5.57,0,0,0-.32-.6C309.13,295.86,307.7,296.55,307.5,296.89Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5,284.89c-.2.35-.07,2.16,3.38,2C285.35,283.75,283.71,284.53,283.5,284.89Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5,260.89c-.2.35-.07,2.16,3.38,2C285.35,259.75,283.71,260.53,283.5,260.89Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M263.92,342.35c-.41,0-1.91,1,0,3.91C265.83,343.37,264.33,342.35,263.92,342.35Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M311.92,342.35c-.3,0-1.16.54-.89,1.93.42.45.84.9,1.27,1.34C313.6,343.22,312.3,342.35,311.92,342.35Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M263.92,366.35c-.41,0-1.91,1,0,3.91C265.83,367.37,264.33,366.35,263.92,366.35Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,354.35c-.41,0-1.91,1,0,3.91C337.83,355.37,336.33,354.35,335.92,354.35Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263.92,318.35c-.41,0-1.91,1,0,3.91C265.83,319.37,264.33,318.35,263.92,318.35Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M311.92,318.35c-.41,0-1.91,1,0,3.91C313.83,319.37,312.33,318.35,311.92,318.35Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M287.92,330.35c-.41,0-1.91,1,0,3.91C289.83,331.37,288.33,330.35,287.92,330.35Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,330.35c-.41,0-1.91,1,0,3.91C337.83,331.37,336.33,330.35,335.92,330.35Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M287.92,306.35c-.41,0-1.91,1,0,3.91C289.83,307.37,288.33,306.35,287.92,306.35Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,306.35c-.41,0-1.91,1,0,3.91C337.83,307.37,336.33,306.35,335.92,306.35Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M265,346.86c3.46.19,3.58-1.62,3.38-2S266.49,343.75,265,346.86Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M313.15,346.5l.36.37c2.91,0,3-1.65,2.83-2S314.62,343.82,313.15,346.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M267.58,368.53a1.82,1.82,0,0,0-1.2.42,4,4,0,0,0-.56.54,5.7,5.7,0,0,0-.54.77.21.21,0,0,1,0,.06c-.09.16-.19.34-.28.54a4.18,4.18,0,0,0,2.86-.6h0a1.8,1.8,0,0,0,.2-.18,1.56,1.56,0,0,0,.25-.36.73.73,0,0,0-.69-1.19Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M337,358.86c3.45.19,3.58-1.62,3.38-2S338.49,355.75,337,358.86Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M265,322.86c3.46.19,3.58-1.62,3.38-2S266.49,319.75,265,322.86Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M316.34,320.89c-.21-.36-1.85-1.14-3.38,2C316.41,323.05,316.54,321.24,316.34,320.89Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M289,334.86a8.4,8.4,0,0,0,.87,0c0-.5.05-1,.07-1.46A6.36,6.36,0,0,0,289,334.86Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M337,334.86c3.45.19,3.58-1.62,3.38-2S338.49,331.75,337,334.86Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M289,310.86c3.46.19,3.58-1.62,3.38-2S290.49,307.75,289,310.86Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M337,310.86c3.45.19,3.58-1.62,3.38-2S338.49,307.75,337,310.86Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M285.29,358.78l.55-1.49c-1.16-1.2-2.18-.68-2.34-.4S283.39,358.43,285.29,358.78Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M355.5,344.89a1.29,1.29,0,0,0,.67,1.48c.21-.58.39-1.18.56-1.79A1.17,1.17,0,0,0,355.5,344.89Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5,356.89c-.21.35-.07,2.16,3.38,2C333.35,355.75,331.71,356.53,331.5,356.89Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M307.5,320.89c-.2.35-.07,2.16,3.38,2C309.35,319.75,307.71,320.53,307.5,320.89Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5,332.89c-.2.35-.07,2.16,3.38,2C285.35,331.75,283.71,332.53,283.5,332.89Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5,332.89c-.21.35-.07,2.16,3.38,2C333.35,331.75,331.71,332.53,331.5,332.89Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5,308.89c-.2.35-.07,2.16,3.38,2C285.35,307.75,283.71,308.53,283.5,308.89Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5,308.89c-.21.35-.07,2.16,3.38,2C333.35,307.75,331.71,308.53,331.5,308.89Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M315.82,298.26h0a1.24,1.24,0,0,0,.52-1.37c-.2-.34-1.63-1-3.06,1.37h0a5.57,5.57,0,0,0-.32.6A4.18,4.18,0,0,0,315.82,298.26Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M267.82,298.26h0a1.24,1.24,0,0,0,.52-1.37c-.2-.34-1.63-1-3.06,1.37h0a5.57,5.57,0,0,0-.32.6A4.18,4.18,0,0,0,267.82,298.26Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M263.92,414.35c-.41,0-1.91,1,0,3.91C265.83,415.37,264.33,414.35,263.92,414.35Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M263.92,438.35c-.41,0-1.91,1,0,3.91C265.83,439.37,264.33,438.35,263.92,438.35Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M287.92,426.35c-.41,0-1.91,1,0,3.91C289.83,427.37,288.33,426.35,287.92,426.35Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M263.92,390.35c-.41,0-1.91,1,0,3.91C265.83,391.37,264.33,390.35,263.92,390.35Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M287.92,402.35c-.41,0-1.91,1,0,3.91C289.83,403.37,288.33,402.35,287.92,402.35Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M265,418.86c3.46.19,3.58-1.62,3.38-2S266.49,415.75,265,418.86Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M267.58,440.53h-.21a1.66,1.66,0,0,0-.73.23l-.26.18a4.62,4.62,0,0,0-1.1,1.31h0a5.57,5.57,0,0,0-.32.6,4.18,4.18,0,0,0,2.86-.6h0a1.24,1.24,0,0,0,.52-1.37A1,1,0,0,0,267.58,440.53Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M289,430.86c3.46.19,3.58-1.62,3.38-2S290.49,427.75,289,430.86Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M265,394.86c3.46.19,3.58-1.62,3.38-2S266.49,391.75,265,394.86Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M289,406.86c3.46.19,3.58-1.62,3.38-2S290.49,403.75,289,406.86Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5,428.89c-.2.35-.07,2.16,3.38,2C285.35,427.75,283.71,428.53,283.5,428.89Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5,404.89c-.2.35-.07,2.16,3.38,2C285.35,403.75,283.71,404.53,283.5,404.89Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M287.92,450.35c-.41,0-1.91,1,0,3.91C289.83,451.37,288.33,450.35,287.92,450.35Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M289,454.86c3.46.19,3.58-1.62,3.38-2S290.49,451.75,289,454.86Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5,452.89c-.2.35-.07,2.16,3.38,2C285.35,451.75,283.71,452.53,283.5,452.89Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,222.35c-.41,0-1.91,1,0,3.91C217.83,223.37,216.33,222.35,215.92,222.35Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M192.49,210.68c0,.54.08,1.29.14,2.23A2.09,2.09,0,0,0,192.49,210.68Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58,224.53a1.82,1.82,0,0,0-1.2.42,4,4,0,0,0-.56.54,5.7,5.7,0,0,0-.54.77l0,.06c-.09.16-.19.34-.28.54a4.18,4.18,0,0,0,2.86-.6h0a1.8,1.8,0,0,0,.2-.18,1.56,1.56,0,0,0,.25-.36,1,1,0,0,0,.07-.83A1,1,0,0,0,219.58,224.53Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M193,214.86c3.46.19,3.58-1.62,3.38-2S194.49,211.75,193,214.86Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M168.84,271.46a1.34,1.34,0,0,0-.13-.44h0a1.45,1.45,0,0,0-.1-.18h0a1.19,1.19,0,0,0-.23-.26h0a.93.93,0,0,0-.24-.15h0a.43.43,0,0,0-.4,0c-.46.2-1.21,1-.37,2.86a8.25,8.25,0,0,0,.57,1,8.25,8.25,0,0,0,.57-1,3.58,3.58,0,0,0,.38-1.51,2.46,2.46,0,0,0,0-.28Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,270.35c-.41,0-1.91,1,0,3.91C217.83,271.37,216.33,270.35,215.92,270.35Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,294.35c-.41,0-1.91,1,0,3.91C217.83,295.37,216.33,294.35,215.92,294.35Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M168.84,295.46a1.34,1.34,0,0,0-.13-.44h0a1.45,1.45,0,0,0-.1-.18h0a1.19,1.19,0,0,0-.23-.26h0a.93.93,0,0,0-.24-.15h0a.43.43,0,0,0-.4,0c-.46.2-1.21,1-.37,2.86a8.25,8.25,0,0,0,.57,1,8.25,8.25,0,0,0,.57-1,3.58,3.58,0,0,0,.38-1.51,2.46,2.46,0,0,0,0-.28Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92,282.35c-.41,0-1.91,1,0,3.91C193.83,283.37,192.33,282.35,191.92,282.35Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92,282.35c-.41,0-1.91,1,0,3.91C241.83,283.37,240.33,282.35,239.92,282.35Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,246.35c-.41,0-1.91,1,0,3.91C217.83,247.37,216.33,246.35,215.92,246.35Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92,258.35c-.41,0-1.91,1,0,3.91C193.83,259.37,192.33,258.35,191.92,258.35Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92,258.35c-.41,0-1.91,1,0,3.91C241.83,259.37,240.33,258.35,239.92,258.35Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M169,274.86c3.46.19,3.58-1.62,3.38-2S170.49,271.75,169,274.86Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M217,274.86c3.45.19,3.58-1.62,3.38-2S218.49,271.75,217,274.86Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M193,286.86c3.46.19,3.58-1.62,3.38-2S194.49,283.75,193,286.86Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M241,286.86c3.45.19,3.58-1.62,3.38-2S242.49,283.75,241,286.86Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M217,250.86c3.45.19,3.58-1.62,3.38-2S218.49,247.75,217,250.86Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M193,262.86c3.46.19,3.58-1.62,3.38-2S194.49,259.75,193,262.86Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M241,262.86c3.45.19,3.58-1.62,3.38-2S242.49,259.75,241,262.86Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M196.34,236.89c-.2-.34-1.66-1-3.11,1.45,0,.18,0,.35,0,.52C196.41,239,196.54,237.23,196.34,236.89Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5,272.89c-.2.35-.07,2.16,3.38,2C213.35,271.75,211.71,272.53,211.5,272.89Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5,296.89a1.24,1.24,0,0,0,.52,1.37h0a4.2,4.2,0,0,0,2.86.6,5.57,5.57,0,0,0-.32-.6C213.13,295.86,211.7,296.55,211.5,296.89Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,284.89c-.2.35-.07,2.16,3.38,2C189.35,283.75,187.71,284.53,187.5,284.89Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5,272.89c-.21.35-.07,2.16,3.38,2C261.35,271.75,259.71,272.53,259.5,272.89Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M262.56,298.26c-1.43-2.4-2.86-1.71-3.06-1.37a1.24,1.24,0,0,0,.52,1.37h0a4.18,4.18,0,0,0,2.86.6,5.57,5.57,0,0,0-.32-.6Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5,284.89c-.21.35-.07,2.16,3.38,2C237.35,283.75,235.71,284.53,235.5,284.89Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5,248.89c-.2.35-.07,2.16,3.38,2C213.35,247.75,211.71,248.53,211.5,248.89Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,260.89c-.2.35-.07,2.16,3.38,2C189.35,259.75,187.71,260.53,187.5,260.89Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5,260.89c-.21.35-.07,2.16,3.38,2C237.35,259.75,235.71,260.53,235.5,260.89Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M237,238.71c-.09-.28-.18-.55-.26-.84s-.22-.87-.32-1.34a1.06,1.06,0,0,0-.92.36C235.34,237.16,235.39,238.3,237,238.71Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M214.56,226.26a5.7,5.7,0,0,0-.54-.77,3.5,3.5,0,0,0-.56-.54,1.82,1.82,0,0,0-1.2-.42,1,1,0,0,0-.76.36,1,1,0,0,0,.07.83,1.56,1.56,0,0,0,.25.36l.2.18h0a4.2,4.2,0,0,0,2.86.6c-.09-.2-.19-.38-.28-.54Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M168.84,343.46a1.34,1.34,0,0,0-.13-.44h0a1.45,1.45,0,0,0-.1-.18h0a1.19,1.19,0,0,0-.23-.26h0a.93.93,0,0,0-.24-.15h0a.43.43,0,0,0-.4,0c-.46.2-1.21,1-.37,2.86a8.25,8.25,0,0,0,.57,1,8.25,8.25,0,0,0,.57-1,3.58,3.58,0,0,0,.38-1.51,2.46,2.46,0,0,0,0-.28Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,342.35c-.41,0-1.91,1,0,3.91C217.83,343.37,216.33,342.35,215.92,342.35Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,366.35c-.41,0-1.91,1,0,3.91C217.83,367.37,216.33,366.35,215.92,366.35Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M168.84,367.46a1.34,1.34,0,0,0-.13-.44h0a1.45,1.45,0,0,0-.1-.18h0a1.19,1.19,0,0,0-.23-.26h0a.93.93,0,0,0-.24-.15h0a.42.42,0,0,0-.4,0c-.46.2-1.21,1-.37,2.86a8.25,8.25,0,0,0,.57,1,8.25,8.25,0,0,0,.57-1,3.58,3.58,0,0,0,.38-1.51,2.46,2.46,0,0,0,0-.28Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92,354.35c-.41,0-1.91,1,0,3.91C193.83,355.37,192.33,354.35,191.92,354.35Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92,354.35c-.41,0-1.91,1,0,3.91C241.83,355.37,240.33,354.35,239.92,354.35Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M168.84,319.46a1.34,1.34,0,0,0-.13-.44h0a1.45,1.45,0,0,0-.1-.18h0a1.19,1.19,0,0,0-.23-.26h0a.93.93,0,0,0-.24-.15h0a.43.43,0,0,0-.4,0c-.46.2-1.21,1-.37,2.86a8.25,8.25,0,0,0,.57,1,8.25,8.25,0,0,0,.57-1,3.58,3.58,0,0,0,.38-1.51,2.46,2.46,0,0,0,0-.28Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,318.35c-.41,0-1.91,1,0,3.91C217.83,319.37,216.33,318.35,215.92,318.35Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92,330.35c-.41,0-1.91,1,0,3.91C193.83,331.37,192.33,330.35,191.92,330.35Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92,330.35c-.41,0-1.91,1,0,3.91C241.83,331.37,240.33,330.35,239.92,330.35Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92,306.35c-.41,0-1.91,1,0,3.91C193.83,307.37,192.33,306.35,191.92,306.35Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92,306.35c-.41,0-1.91,1,0,3.91C241.83,307.37,240.33,306.35,239.92,306.35Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M169,346.86c3.46.19,3.58-1.62,3.38-2S170.49,343.75,169,346.86Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M217,346.86c3.45.19,3.58-1.62,3.38-2S218.49,343.75,217,346.86Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58,368.53a1.82,1.82,0,0,0-1.2.42,4,4,0,0,0-.56.54,5.7,5.7,0,0,0-.54.77l0,.06c-.09.16-.19.34-.28.54a4.18,4.18,0,0,0,2.86-.6h0a1.8,1.8,0,0,0,.2-.18,1.56,1.56,0,0,0,.25-.36,1,1,0,0,0,.07-.83A1,1,0,0,0,219.58,368.53Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M171.58,368.53a1.82,1.82,0,0,0-1.2.42,4,4,0,0,0-.56.54,5.7,5.7,0,0,0-.54.77l0,.06c-.09.16-.19.34-.28.54a4.18,4.18,0,0,0,2.86-.6h0a1.8,1.8,0,0,0,.2-.18,1.56,1.56,0,0,0,.25-.36.73.73,0,0,0-.69-1.19Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M193,358.86c3.46.19,3.58-1.62,3.38-2S194.49,355.75,193,358.86Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M241,358.86c3.45.19,3.58-1.62,3.38-2S242.49,355.75,241,358.86Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M169,322.86c3.46.19,3.58-1.62,3.38-2S170.49,319.75,169,322.86Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M217,322.86c3.45.19,3.58-1.62,3.38-2S218.49,319.75,217,322.86Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M193,334.86c3.46.19,3.58-1.62,3.38-2S194.49,331.75,193,334.86Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M241,334.86c3.45.19,3.58-1.62,3.38-2S242.49,331.75,241,334.86Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M193,310.86c3.46.19,3.58-1.62,3.38-2S194.49,307.75,193,310.86Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M241,310.86c3.45.19,3.58-1.62,3.38-2S242.49,307.75,241,310.86Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5,344.89c-.2.35-.07,2.16,3.38,2C213.35,343.75,211.71,344.53,211.5,344.89Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,356.89c-.2.35-.07,2.16,3.38,2C189.35,355.75,187.71,356.53,187.5,356.89Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5,344.89c-.21.35-.07,2.16,3.38,2C261.35,343.75,259.71,344.53,259.5,344.89Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5,356.89c-.21.35-.07,2.16,3.38,2C237.35,355.75,235.71,356.53,235.5,356.89Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M173.59,373.26s26,6.67,58.66-18.66,45.34-15.34,44,2.66-29.33,34.67-41.33,36.67C215.19,397.22,197.59,402.6,173.59,373.26Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5,320.89c-.2.35-.07,2.16,3.38,2C213.35,319.75,211.71,320.53,211.5,320.89Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,332.89c-.2.35-.07,2.16,3.38,2C189.35,331.75,187.71,332.53,187.5,332.89Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5,320.89c-.21.35-.07,2.16,3.38,2C261.35,319.75,259.71,320.53,259.5,320.89Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5,332.89c-.21.35-.07,2.16,3.38,2C237.35,331.75,235.71,332.53,235.5,332.89Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,308.89c-.2.35-.07,2.16,3.38,2C189.35,307.75,187.71,308.53,187.5,308.89Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5,308.89c-.21.35-.07,2.16,3.38,2C237.35,307.75,235.71,308.53,235.5,308.89Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M219.82,298.26h0a1.24,1.24,0,0,0,.52-1.37c-.2-.34-1.63-1-3.06,1.37h0a5.57,5.57,0,0,0-.32.6A4.18,4.18,0,0,0,219.82,298.26Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M171.82,298.26h0a1.24,1.24,0,0,0,.52-1.37c-.2-.34-1.63-1-3.06,1.37h0a5.57,5.57,0,0,0-.32.6A4.18,4.18,0,0,0,171.82,298.26Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M168.84,415.46a1.34,1.34,0,0,0-.13-.44h0a1.45,1.45,0,0,0-.1-.18h0a1.19,1.19,0,0,0-.23-.26h0a.93.93,0,0,0-.24-.15h0a.42.42,0,0,0-.4,0c-.46.2-1.21,1-.37,2.86a8.25,8.25,0,0,0,.57,1,8.25,8.25,0,0,0,.57-1,3.58,3.58,0,0,0,.38-1.51,2.46,2.46,0,0,0,0-.28Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,414.35c-.41,0-1.91,1,0,3.91C217.83,415.37,216.33,414.35,215.92,414.35Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,438.35c-.41,0-1.91,1,0,3.91C217.83,439.37,216.33,438.35,215.92,438.35Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M168.84,439.46a1.34,1.34,0,0,0-.13-.44h0a1.45,1.45,0,0,0-.1-.18h0a1.19,1.19,0,0,0-.23-.26h0a.93.93,0,0,0-.24-.15h0a.42.42,0,0,0-.4,0c-.46.2-1.21,1-.37,2.86a8.25,8.25,0,0,0,.57,1,8.25,8.25,0,0,0,.57-1,3.58,3.58,0,0,0,.38-1.51,2.46,2.46,0,0,0,0-.28Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92,426.35c-.41,0-1.91,1,0,3.91C193.83,427.37,192.33,426.35,191.92,426.35Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92,426.35c-.41,0-1.91,1,0,3.91C241.83,427.37,240.33,426.35,239.92,426.35Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M168.84,391.46a1.34,1.34,0,0,0-.13-.44h0a1.45,1.45,0,0,0-.1-.18h0a1.19,1.19,0,0,0-.23-.26h0a.93.93,0,0,0-.24-.15h0a.42.42,0,0,0-.4,0c-.46.2-1.21,1-.37,2.86a8.25,8.25,0,0,0,.57,1,8.25,8.25,0,0,0,.57-1,3.58,3.58,0,0,0,.38-1.51,2.46,2.46,0,0,0,0-.28Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M215.92,390.35c-.41,0-1.91,1,0,3.91C217.83,391.37,216.33,390.35,215.92,390.35Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92,402.35c-.41,0-1.91,1,0,3.91C193.83,403.37,192.33,402.35,191.92,402.35Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92,402.35c-.41,0-1.91,1,0,3.91C241.83,403.37,240.33,402.35,239.92,402.35Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92,378.35c-.41,0-1.91,1,0,3.91C193.83,379.37,192.33,378.35,191.92,378.35Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92,378.35c-.41,0-1.91,1,0,3.91C241.83,379.37,240.33,378.35,239.92,378.35Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M169,418.86c3.46.19,3.58-1.62,3.38-2S170.49,415.75,169,418.86Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M217,418.86c3.45.19,3.58-1.62,3.38-2S218.49,415.75,217,418.86Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58,440.53h-.21a1.66,1.66,0,0,0-.73.23l-.26.18a4.62,4.62,0,0,0-1.1,1.31h0a5.57,5.57,0,0,0-.32.6,4.18,4.18,0,0,0,2.86-.6h0a1.24,1.24,0,0,0,.52-1.37A1,1,0,0,0,219.58,440.53Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M171.58,440.53h-.21a1.66,1.66,0,0,0-.73.23l-.26.18a4.62,4.62,0,0,0-1.1,1.31h0a5.57,5.57,0,0,0-.32.6,4.18,4.18,0,0,0,2.86-.6h0a1.24,1.24,0,0,0,.52-1.37A1,1,0,0,0,171.58,440.53Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M193,430.86c3.46.19,3.58-1.62,3.38-2S194.49,427.75,193,430.86Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M241,430.86c3.45.19,3.58-1.62,3.38-2S242.49,427.75,241,430.86Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M169,394.86c3.46.19,3.58-1.62,3.38-2S170.49,391.75,169,394.86Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M217,394.86c3.45.19,3.58-1.62,3.38-2S218.49,391.75,217,394.86Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M193,406.86c3.46.19,3.58-1.62,3.38-2S194.49,403.75,193,406.86Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M241,406.86c3.45.19,3.58-1.62,3.38-2S242.49,403.75,241,406.86Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M193,382.86c3.46.19,3.58-1.62,3.38-2S194.49,379.75,193,382.86Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M241,382.86c3.45.19,3.58-1.62,3.38-2S242.49,379.75,241,382.86Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5,416.89c-.2.35-.07,2.16,3.38,2C213.35,415.75,211.71,416.53,211.5,416.89Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M213.46,441l-.26-.18a1.62,1.62,0,0,0-.73-.23h-.21a1,1,0,0,0-.76.36,1.24,1.24,0,0,0,.52,1.37h0a4.2,4.2,0,0,0,2.86.6,5.57,5.57,0,0,0-.32-.6A4.46,4.46,0,0,0,213.46,441Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,428.89c-.2.35-.07,2.16,3.38,2C189.35,427.75,187.71,428.53,187.5,428.89Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5,416.89c-.21.35-.07,2.16,3.38,2C261.35,415.75,259.71,416.53,259.5,416.89Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M262.56,442.26a4.62,4.62,0,0,0-1.1-1.31l-.26-.18a1.66,1.66,0,0,0-.73-.23h-.21a1,1,0,0,0-.76.36,1.24,1.24,0,0,0,.52,1.37h0a4.18,4.18,0,0,0,2.86.6,5.57,5.57,0,0,0-.32-.6Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5,428.89c-.21.35-.07,2.16,3.38,2C237.35,427.75,235.71,428.53,235.5,428.89Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5,392.89c-.2.35-.07,2.16,3.38,2C213.35,391.75,211.71,392.53,211.5,392.89Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,404.89c-.2.35-.07,2.16,3.38,2C189.35,403.75,187.71,404.53,187.5,404.89Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5,392.89c-.21.35-.07,2.16,3.38,2C261.35,391.75,259.71,392.53,259.5,392.89Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5,404.89c-.21.35-.07,2.16,3.38,2C237.35,403.75,235.71,404.53,235.5,404.89Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,380.89c-.2.35-.07,2.16,3.38,2C189.35,379.75,187.71,380.53,187.5,380.89Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5,380.89c-.21.35-.07,2.16,3.38,2C237.35,379.75,235.71,380.53,235.5,380.89Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M214.56,370.26a5.7,5.7,0,0,0-.54-.77,3.5,3.5,0,0,0-.56-.54,1.82,1.82,0,0,0-1.2-.42,1,1,0,0,0-.76.36,1,1,0,0,0,.07.83,1.56,1.56,0,0,0,.25.36l.2.18h0a4.2,4.2,0,0,0,2.86.6c-.09-.2-.19-.38-.28-.54Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M262.56,370.26a5.7,5.7,0,0,0-.54-.77,4,4,0,0,0-.56-.54,1.82,1.82,0,0,0-1.2-.42,1,1,0,0,0-.76.36,1,1,0,0,0,.07.83,1.56,1.56,0,0,0,.25.36,1.8,1.8,0,0,0,.2.18h0a4.18,4.18,0,0,0,2.86.6c-.09-.2-.19-.38-.28-.54A.21.21,0,0,1,262.56,370.26Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M191.92,450.35c-.41,0-1.91,1,0,3.91C193.83,451.37,192.33,450.35,191.92,450.35Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M239.92,450.35c-.41,0-1.91,1,0,3.91C241.83,451.37,240.33,450.35,239.92,450.35Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M193,454.86c3.46.19,3.58-1.62,3.38-2S194.49,451.75,193,454.86Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M241,454.86c3.45.19,3.58-1.62,3.38-2S242.49,451.75,241,454.86Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,452.89c-.2.35-.07,2.16,3.38,2C189.35,451.75,187.71,452.53,187.5,452.89Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5,452.89c-.21.35-.07,2.16,3.38,2C237.35,451.75,235.71,452.53,235.5,452.89Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M119.92,294.35c-.41,0-1.91,1,0,3.91C121.83,295.37,120.33,294.35,119.92,294.35Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92,282.35c-.41,0-1.91,1,0,3.91C145.83,283.37,144.33,282.35,143.92,282.35Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M144.8,259.27l-1.83.47a4.65,4.65,0,0,0,.95,2.52C144.85,260.86,145,259.89,144.8,259.27Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M121,274.86c3.45.19,3.58-1.62,3.38-2S122.49,271.75,121,274.86Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M145,286.86c3.45.19,3.58-1.62,3.38-2S146.49,283.75,145,286.86Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M145,262.86c3.45.19,3.58-1.62,3.38-2S146.49,259.75,145,262.86Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5,296.89a1.24,1.24,0,0,0,.52,1.37h0a4.2,4.2,0,0,0,2.86.6,5.57,5.57,0,0,0-.32-.6C117.13,295.86,115.7,296.55,115.5,296.89Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5,272.89c-.21.35-.07,2.16,3.38,2C165.35,271.75,163.71,272.53,163.5,272.89Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M166.56,298.26c-1.43-2.4-2.86-1.71-3.06-1.37a1.24,1.24,0,0,0,.52,1.37h0a4.18,4.18,0,0,0,2.86.6,5.57,5.57,0,0,0-.32-.6Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5,284.89c-.21.35-.07,2.16,3.38,2C141.35,283.75,139.71,284.53,139.5,284.89Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M140.23,260.54l-.52.16a.66.66,0,0,0-.21.19c-.21.35-.07,2.16,3.38,2C141.91,260.88,140.9,260.48,140.23,260.54Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M71.92,342.35c-.41,0-1.91,1,0,3.91C73.83,343.37,72.33,342.35,71.92,342.35Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M95.92,354.35c-.41,0-1.91,1,0,3.91C97.83,355.37,96.33,354.35,95.92,354.35Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M119.92,318.35c-.41,0-1.91,1,0,3.91C121.83,319.37,120.33,318.35,119.92,318.35Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M95.92,330.35c-.41,0-1.91,1,0,3.91C97.83,331.37,96.33,330.35,95.92,330.35Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92,330.35c-.41,0-1.91,1,0,3.91C145.83,331.37,144.33,330.35,143.92,330.35Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M95.92,306.35c-.41,0-1.91,1,0,3.91C97.83,307.37,96.33,306.35,95.92,306.35Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92,306.35c-.41,0-1.91,1,0,3.91C145.83,307.37,144.33,306.35,143.92,306.35Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M73,346.86c3.46.19,3.59-1.62,3.38-2S74.49,343.75,73,346.86Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M97.55,357.84c.89-.33,1.76-.7,2.62-1.12C99.75,356.44,98.67,356.25,97.55,357.84Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M76.34,320.89a.84.84,0,0,0-.47-.3c-.62.79-1.21,1.54-1.72,2.25C76.44,322.6,76.52,321.2,76.34,320.89Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M121,322.86c3.45.19,3.58-1.62,3.38-2S122.49,319.75,121,322.86Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M97,334.86c3.46.19,3.58-1.62,3.38-2S98.49,331.75,97,334.86Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M145,334.86c3.45.19,3.58-1.62,3.38-2S146.49,331.75,145,334.86Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M97,310.86c3.46.19,3.58-1.62,3.38-2S98.49,307.75,97,310.86Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M145,310.86c3.45.19,3.58-1.62,3.38-2S146.49,307.75,145,310.86Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5,356.89c-.19.32-.09,1.84,2.54,2l.75-.17C93.29,355.79,91.71,356.54,91.5,356.89Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5,344.89c-.21.35-.07,2.16,3.38,2C165.35,343.75,163.71,344.53,163.5,344.89Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5,320.89c-.2.35-.07,2.16,3.38,2C117.35,319.75,115.71,320.53,115.5,320.89Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5,332.89c-.2.35-.07,2.16,3.38,2C93.35,331.75,91.71,332.53,91.5,332.89Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5,320.89c-.21.35-.07,2.16,3.38,2C165.35,319.75,163.71,320.53,163.5,320.89Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5,308.89c-.2.35-.07,2.16,3.38,2C93.35,307.75,91.71,308.53,91.5,308.89Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5,308.89c-.21.35-.07,2.16,3.38,2C141.35,307.75,139.71,308.53,139.5,308.89Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M123.82,298.26h0a1.24,1.24,0,0,0,.52-1.37c-.2-.34-1.63-1-3.06,1.37h0a5.57,5.57,0,0,0-.32.6A4.18,4.18,0,0,0,123.82,298.26Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92,426.35c-.41,0-1.91,1,0,3.91C145.83,427.37,144.33,426.35,143.92,426.35Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M144.69,404.74l-.84,1.41.07.11A6.38,6.38,0,0,0,144.69,404.74Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M145,430.86c3.45.19,3.58-1.62,3.38-2S146.49,427.75,145,430.86Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M145,406.86c3.45.19,3.58-1.62,3.38-2S146.49,403.75,145,406.86Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5,416.89c-.21.35-.07,2.16,3.38,2C165.35,415.75,163.71,416.53,163.5,416.89Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M166.56,442.26a4.62,4.62,0,0,0-1.1-1.31l-.26-.18a1.66,1.66,0,0,0-.73-.23h-.21a1,1,0,0,0-.76.36,1.24,1.24,0,0,0,.52,1.37h0a4.18,4.18,0,0,0,2.86.6,5.57,5.57,0,0,0-.32-.6Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5,428.89c-.21.35-.07,2.16,3.38,2C141.35,427.75,139.71,428.53,139.5,428.89Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5,392.89c-.21.35-.07,2.16,3.38,2C165.35,391.75,163.71,392.53,163.5,392.89Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M166.56,370.26a5.7,5.7,0,0,0-.54-.77,4,4,0,0,0-.56-.54,1.82,1.82,0,0,0-1.2-.42,1,1,0,0,0-.76.36,1,1,0,0,0,.07.83,1.56,1.56,0,0,0,.25.36,1.8,1.8,0,0,0,.2.18h0a4.18,4.18,0,0,0,2.86.6c-.09-.2-.19-.38-.28-.54Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92,450.35c-.41,0-1.91,1,0,3.91C145.83,451.37,144.33,450.35,143.92,450.35Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M145,454.86c3.45.19,3.58-1.62,3.38-2S146.49,451.75,145,454.86Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5,452.89c-.21.35-.07,2.16,3.38,2C141.35,451.75,139.71,452.53,139.5,452.89Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M69.57,345.05a18.93,18.93,0,0,0,.69,1.82h.62A5.37,5.37,0,0,0,69.57,345.05Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M303.22,455.26s1.79-24.55-9-49.11S281,379.82,281,372.63s7.22-15.58,8.42-31.75.6-24,.6-24,25.75,40.72,43.72,43.12,28.75-14.37,22.16-37.13-35.34-41.32-46.71-56.3-37.14-15-50.31-15-19.76-4.79-22.16-13.77-2.39-27-2.39-27-15.58,9.58-41.93-1.2c0,0,2.4,32.94-.6,37.73S184.64,257,166.67,257s-32.94,3.6-41.32,12-43.12,41.92-52.1,55.1-4.2,27.55,6.58,32.94,21.56.59,29.35-6.59,32.34-29.95,32.34-29.95,0,13.78,6.59,33.54,12,17.37,7.18,31.74-14.37,18.57-17.36,37.13a176.46,176.46,0,0,0-2.4,32.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.52,320.51a75.26,75.26,0,0,1,3.95-19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,316.92a74,74,0,0,0-5.47-14.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.03,
    y1: 383.3,
    x2: 239.75,
    y2: 371.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.11,373.34a122.25,122.25,0,0,1,27.4-7.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.59,297.16c29.88,5.76,41.41-22.88,45.42-45.77-9.95-1.1-15.19-5.73-17.27-13.52-2.39-9-2.39-27-2.39-27s-15.58,9.58-41.93-1.2c0,0,2.4,32.94-.6,37.73-2.08,3.34-4.76,6.68-12.26,8.39C179.29,266.07,181.36,291.9,208.59,297.16Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.09,234.91c-1.74-9.46-1.74-24-1.74-24s-15.58,9.58-41.93-1.2c0,0,1,13.77.9,24.8C216,242.39,229.12,239.05,236.09,234.91Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.59,297.16c29.88,5.76,41.41-22.88,45.42-45.77-9.95-1.1-15.19-5.73-17.27-13.52-2.39-9-2.39-27-2.39-27s-15.58,9.58-41.93-1.2c0,0,2.4,32.94-.6,37.73-2.08,3.34-4.76,6.68-12.26,8.39C179.29,266.07,181.36,291.9,208.59,297.16Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.77,
    cy: 192.01,
    r: 7.42,
    className: "colorToChange",
    style: {
      fill: "#339F9A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.51,
    cy: 192.01,
    r: 7.42,
    className: "colorToChange",
    style: {
      fill: "#339F9A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.09,166.72s3.71-11.47,8.1-7.42-1.35,19.56-4.39,23.27-6.07,3.71-5.73-1.35S253.09,166.72,253.09,166.72Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.39,178.26s1,26.79,20.72,39.93,34.37,5.56,42.46-5.56,13.15-22.24,13.15-38.41,2-23.26-3.54-33.37-24.77-15.16-24.77-15.16A303.44,303.44,0,0,1,198.63,154C183.46,168.65,176.39,178.26,176.39,178.26Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.41,125.69A303.44,303.44,0,0,1,198.63,154c-15.17,14.65-22.24,24.26-22.24,24.26a61.43,61.43,0,0,0,3.07,15.33c26.64-20.38,41.19-57,45.06-67.87Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.39,178.26s1,26.79,20.72,39.93,34.37,5.56,42.46-5.56,13.15-22.24,13.15-38.41,2-23.26-3.54-33.37-24.77-15.16-24.77-15.16A303.44,303.44,0,0,1,198.63,154C183.46,168.65,176.39,178.26,176.39,178.26Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.04,
    y1: 175.11,
    x2: 206.39,
    y2: 176.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.44,174.75s7.45-1.42,11,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.86,169.92c0,2.7-1.21,4.89-2.7,4.89s-2.69-2.19-2.69-4.89,1.2-4.89,2.69-4.89S204.86,167.22,204.86,169.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.93,187a9.86,9.86,0,0,0,11.81-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,198.42s10.45,4.39,16.52-9.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.46,170.09s6.41-4.39,12.82-1.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.44,159s7.08-7.08,16.86-1.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.26,154.57s-6.07-6.07-14.51-.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.25,324.11s-10.78,12-10.78,24.55,7.18,24,27,41.92,38.32,31.14,46.11,35.34,15.57-1.2,15.57-1.2,12.88,12.87,14.37,9.88-4.49-7.49-5.69-9.28a24.6,24.6,0,0,0-3.59-3.89s6.29.89,8.69,3,6.28,5.69,8.08,5.39,1.8-1.8-.9-5.39a32.06,32.06,0,0,0-7.78-7.19c-1.8-1.19-7.79-4.49-7.79-4.49s8.68-.6,11.68,1.2,11.08,7.19,11.68,4.79.6-3.89-2.4-6.59-9-6-12.57-6.59a37.13,37.13,0,0,1-7.19-2.09s6.89-2.4,9.28-2.4,12,4.79,14.67,4.2,1.2-3-.89-4.5-11.38-5.09-15.28-5.39-25.75,7.19-28.44,7.19-9.58-9.58-16.77-22.46-9.88-32.94-25.15-39.82",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M71.92,346.26c1.91-2.89.41-3.91,0-3.91C72.33,342.35,73.83,343.37,71.92,346.26Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M71.92,366.35c.41,0,1.91,1,0,3.91C73.83,367.37,72.33,366.35,71.92,366.35Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M95.92,354.35c-.41,0-1.91,1,0,3.91C97.83,355.37,96.33,354.35,95.92,354.35Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M76.34,344.89c-.21-.36-1.85-1.14-3.38,2C76.42,347.05,76.55,345.24,76.34,344.89Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M76,370.08a1.56,1.56,0,0,0,.25-.36.73.73,0,0,0-.69-1.19,1.82,1.82,0,0,0-1.2.42,4,4,0,0,0-.56.54,5.7,5.7,0,0,0-.54.77h2.54A1.8,1.8,0,0,0,76,370.08Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M100.34,356.89c-.21-.36-1.85-1.14-3.38,2C100.42,359.05,100.54,357.24,100.34,356.89Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M94.88,358.86c-1.53-3.11-3.17-2.33-3.38-2S91.43,359.05,94.88,358.86Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M71.92,342.35v3.91C73.83,343.37,72.33,342.35,71.92,342.35Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M71.92,366.35v3.91C73.83,367.37,72.33,366.35,71.92,366.35Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M119.92,414.35a1.08,1.08,0,0,0-.79.67l1.69,1.24C121.07,414.88,120.22,414.35,119.92,414.35Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92,426.35a1.21,1.21,0,0,0-.92,1.11,16.45,16.45,0,0,0,1.79-.24A1.15,1.15,0,0,0,143.92,426.35Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M119.92,390.35c-.41,0-1.91,1,0,3.91C121.83,391.37,120.33,390.35,119.92,390.35Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M143.92,406.26c1.91-2.89.41-3.91,0-3.91S142,403.37,143.92,406.26Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M95.92,382.26c1.91-2.89.41-3.91,0-3.91S94,379.37,95.92,382.26Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M124.34,416.89c-.16-.27-1.12-.78-2.23.29.54.4,1.08.78,1.61,1.15A1.26,1.26,0,0,0,124.34,416.89Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M121,394.86c3.45.19,3.58-1.62,3.38-2S122.49,391.75,121,394.86Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M145,406.86c3.45.19,3.58-1.62,3.38-2S146.49,403.75,145,406.86Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M97,382.86c3.46.19,3.58-1.62,3.38-2S98.49,379.75,97,382.86Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M166.53,418.87c-.86-.68-1.65-1.23-2.25-1.64l-.7-.44-.08.1C163.3,417.23,163.43,418.92,166.53,418.87Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M118.88,394.86c-1.53-3.11-3.17-2.33-3.38-2S115.43,395.05,118.88,394.86Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5,404.89c-.21.35-.07,2.16,3.38,2C141.35,403.75,139.71,404.53,139.5,404.89Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5,380.89c-.2.35-.07,2.16,3.38,2C93.35,379.75,91.71,380.53,91.5,380.89Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M75.82,370.26H73.28a.21.21,0,0,1,0,.06c-.09.16-.19.34-.28.54A4.18,4.18,0,0,0,75.82,370.26Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M71.92,342.35c-.41,0-1.91,1,0,3.91Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M71.92,370.26v-3.91C71.51,366.35,70,367.37,71.92,370.26Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M70.88,346.86c-1.53-3.11-3.17-2.33-3.38-2S67.43,347.05,70.88,346.86Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M70,369.49a4,4,0,0,0-.56-.54l-.07-.05c.31.45.62.91,1,1.36h.22A5.7,5.7,0,0,0,70,369.49Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6,370.32a.21.21,0,0,1,0-.06h-.22l.44.6h.1C70.79,370.66,70.69,370.48,70.6,370.32Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M73.25,324.11s-10.78,12-10.78,24.55,7.18,24,27,41.92,38.32,31.14,46.11,35.34,15.57-1.2,15.57-1.2,12.88,12.87,14.37,9.88-4.49-7.49-5.69-9.28a24.6,24.6,0,0,0-3.59-3.89s6.29.89,8.69,3,6.28,5.69,8.08,5.39,1.8-1.8-.9-5.39a32.06,32.06,0,0,0-7.78-7.19c-1.8-1.19-7.79-4.49-7.79-4.49s8.68-.6,11.68,1.2,11.08,7.19,11.68,4.79.6-3.89-2.4-6.59-9-6-12.57-6.59a37.13,37.13,0,0,1-7.19-2.09s6.89-2.4,9.28-2.4,12,4.79,14.67,4.2,1.2-3-.89-4.5-11.38-5.09-15.28-5.39-25.75,7.19-28.44,7.19-9.58-9.58-16.77-22.46-9.88-32.94-25.15-39.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.75,400.76c-2.1-1.49-11.38-5.09-15.28-5.39s-25.75,7.19-28.44,7.19-9.58-9.58-16.77-22.46c-4-7.15-6.6-16.52-10.75-24.61-22-3-31.43,9.86-35.79,19.11a160.66,160.66,0,0,0,15.7,16c19.76,18,38.32,31.14,46.11,35.34s15.57-1.2,15.57-1.2,12.88,12.87,14.37,9.88-4.49-7.49-5.69-9.28a24.6,24.6,0,0,0-3.59-3.89s6.29.89,8.69,3,6.28,5.69,8.08,5.39,1.8-1.8-.9-5.39a32.06,32.06,0,0,0-7.78-7.19c-1.8-1.19-7.79-4.49-7.79-4.49s8.68-.6,11.68,1.2,11.08,7.19,11.68,4.79.6-3.89-2.4-6.59-9-6-12.57-6.59a37.13,37.13,0,0,1-7.19-2.09s6.89-2.4,9.28-2.4,12,4.79,14.67,4.2S182.84,402.26,180.75,400.76Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.76,335.35c-2.5-5.71-.36-18.21,2.14-36.06s5-36.06,5-45.7,1.59-23-1.55-27.31-14.57-16-15.42-21.42,6.85-13.71,6.85-13.71,2.29-4.29,4.29-2,1.14,5.14,0,9.14-2.29,7.14-2.29,7.14,10,3.14,12.57,1.43,2.34-11.49,2.16-16.28c-.37-9.34-4.11-5.35-6.7-.93-1.25,2.12-8.57.86-4.29-4.57s8.26-10.22,12.26-5.93,6.85,12.57,6.85,12.57,2.86-13.61,5.46-21.61,7.26-11.17,8.94-10.61,1.49,3.35-.19,7.26-5.4,14.7-6.33,18.24-1.11,7.63.75,7.26,8.37-11.73,10.24-16.57,4.65-9.3,7.81-11.35,5.77.56,4.47,3.91A170.27,170.27,0,0,1,355,185.93a76.4,76.4,0,0,0-5.21,11.54,131.25,131.25,0,0,1,9.68-9.31c4.47-3.72,9.31-4.46,10.79-3.16s.19,1.49-3.53,4.47S357.45,196,353,203.24a68.36,68.36,0,0,0-8,17.12,58.05,58.05,0,0,1-5.4,11.36s3.49,28.34,9.54,43.93,16.75,38.39,13.49,54.68-9.54,24.66-18.38,27.22a17.09,17.09,0,0,1-15.12-2.79",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-15)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M359.92,174.35a1.11,1.11,0,0,1,.8.69h0A1.08,1.08,0,0,0,359.92,174.35Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M359.92,174.35v2.34l.8-1.65A1.11,1.11,0,0,0,359.92,174.35Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M359.92,322.26c1.91-2.89.41-3.91,0-3.91C360.33,318.35,361.83,319.37,359.92,322.26Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M363.19,322.6q0-1-.09-2c-.62.16-1.4.75-2.14,2.27A5.44,5.44,0,0,0,363.19,322.6Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M359.92,318.35v3.91C361.83,319.37,360.33,318.35,359.92,318.35Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M311.92,198.35c-.35,0-1.45.73-.67,2.66.25-.81.52-1.7.79-2.64Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,214.26c1.91-2.89.41-3.91,0-3.91S334,211.37,335.92,214.26Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M359.5,177.54l.42-.85v-2.34C359.54,174.35,358.27,175.21,359.5,177.54Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,186.35c-.41,0-1.91,1,0,3.91C337.83,187.37,336.33,186.35,335.92,186.35Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M316.27,225.72a1,1,0,0,0,.07-.83,1,1,0,0,0-.76-.36,1.63,1.63,0,0,0-.55.08c.41.5.78.95,1.08,1.35A1.11,1.11,0,0,0,316.27,225.72Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M340.34,212.89c-.21-.36-1.85-1.14-3.38,2C340.41,215.05,340.54,213.24,340.34,212.89Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M339.85,190.24a11.6,11.6,0,0,1,0-1.65c-.64-.2-1.81,0-2.92,2.27A4.13,4.13,0,0,0,339.85,190.24Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M340.37,165c-.27.45-.52.94-.78,1.45A1.37,1.37,0,0,0,340.37,165Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M307.5,200.89c-.2.34-.07,2.08,3.16,2l.09-.26C309.26,199.81,307.71,200.54,307.5,200.89Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5,212.89c-.21.35-.07,2.16,3.38,2C333.35,211.75,331.71,212.53,331.5,212.89Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M355.5,176.89c-.2.35-.07,2.15,3.34,2l0,0C357.34,175.76,355.71,176.53,355.5,176.89Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M334.88,190.86a4.71,4.71,0,0,0-1.62-2c-.16.75-.3,1.38-.4,1.86A5.83,5.83,0,0,0,334.88,190.86Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M332.11,190.33c-.16-.42-.36-.91-.59-1.46l0,0A1.27,1.27,0,0,0,332.11,190.33Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,286.26c1.91-2.89.41-3.91,0-3.91S334,283.37,335.92,286.26Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,258.35c-.41,0-1.91,1,0,3.91C337.83,259.37,336.33,258.35,335.92,258.35Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,234.35c-.41,0-1.91,1,0,3.91C337.83,235.37,336.33,234.35,335.92,234.35Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M316.38,273c0,.21-.05.43-.08.64A1.1,1.1,0,0,0,316.38,273Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M316.34,296.89c-.2-.34-1.63-1-3.06,1.37h2.54A1.24,1.24,0,0,0,316.34,296.89Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M337,286.86c3.45.19,3.58-1.62,3.38-2S338.49,283.75,337,286.86Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M340.34,260.89c-.21-.36-1.85-1.14-3.38,2C340.41,263.05,340.54,261.24,340.34,260.89Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M337,238.86c2.54.14,3.28-.8,3.41-1.45l-.09-.59C339.94,236.45,338.4,235.93,337,238.86Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M357.41,296.91c-1-.69-1.77-.27-1.91,0a1.24,1.24,0,0,0,.52,1.37h1.86Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5,284.89c-.21.35-.07,2.16,3.38,2C333.35,283.75,331.71,284.53,331.5,284.89Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5,260.89c-.21.35-.07,2.16,3.38,2C333.35,259.75,331.71,260.53,331.5,260.89Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5,236.89c-.21.35-.07,2.16,3.38,2C333.35,235.75,331.71,236.53,331.5,236.89Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,354.35c-.39,0-1.75.92-.28,3.46l.5.1C337.7,355.29,336.31,354.35,335.92,354.35Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M311.92,322.26c1.91-2.89.41-3.91,0-3.91S310,319.37,311.92,322.26Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M359.92,318.35c-.41,0-1.91,1,0,3.91Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,334.26c1.91-2.89.41-3.91,0-3.91S334,331.37,335.92,334.26Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M335.92,306.35c-.41,0-1.91,1,0,3.91C337.83,307.37,336.33,306.35,335.92,306.35Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M340.34,356.89c-.19-.33-1.56-1-3,1.21a16.59,16.59,0,0,0,2.48.13A1.23,1.23,0,0,0,340.34,356.89Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M313,322.86c3.45.19,3.58-1.62,3.38-2S314.49,319.75,313,322.86Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M337,334.86c3.45.19,3.58-1.62,3.38-2S338.49,331.75,337,334.86Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M340.34,308.89c-.21-.36-1.85-1.14-3.38,2C340.41,311.05,340.54,309.24,340.34,308.89Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M355.5,344.89c-.16.27-.11,1.4,1.49,1.82.27-.48.54-1,.79-1.47C356.65,344.1,355.66,344.61,355.5,344.89Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M332.07,356.56a18.59,18.59,0,0,0,1.75.72A1.9,1.9,0,0,0,332.07,356.56Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M310.88,322.86a6,6,0,0,0-.89-1.4c0,.47-.08.93-.11,1.39A8.18,8.18,0,0,0,310.88,322.86Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M358.88,322.86c-1.53-3.11-3.17-2.33-3.38-2S355.43,323.05,358.88,322.86Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5,332.89c-.21.35-.07,2.16,3.38,2C333.35,331.75,331.71,332.53,331.5,332.89Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5,308.89c-.21.35-.07,2.16,3.38,2C333.35,307.75,331.71,308.53,331.5,308.89Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M313.28,298.26c-.11.18-.21.38-.32.59h0a4.18,4.18,0,0,0,2.86-.6h-2.54Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M357.88,298.26H356a3.55,3.55,0,0,0,2.07.6Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M310.76,335.35c-2.5-5.71-.36-18.21,2.14-36.06s5-36.06,5-45.7,1.59-23-1.55-27.31-14.57-16-15.42-21.42,6.85-13.71,6.85-13.71,2.29-4.29,4.29-2,1.14,5.14,0,9.14-2.29,7.14-2.29,7.14,10,3.14,12.57,1.43,2.34-11.49,2.16-16.28c-.37-9.34-4.11-5.35-6.7-.93-1.25,2.12-8.57.86-4.29-4.57s8.26-10.22,12.26-5.93,6.85,12.57,6.85,12.57,2.86-13.61,5.46-21.61,7.26-11.17,8.94-10.61,1.49,3.35-.19,7.26-5.4,14.7-6.33,18.24-1.11,7.63.75,7.26,8.37-11.73,10.24-16.57,4.65-9.3,7.81-11.35,5.77.56,4.47,3.91A170.27,170.27,0,0,1,355,185.93a76.4,76.4,0,0,0-5.21,11.54,131.25,131.25,0,0,1,9.68-9.31c4.47-3.72,9.31-4.46,10.79-3.16s.19,1.49-3.53,4.47S357.45,196,353,203.24a68.36,68.36,0,0,0-8,17.12,58.05,58.05,0,0,1-5.4,11.36s3.49,28.34,9.54,43.93,16.75,38.39,13.49,54.68-9.54,24.66-18.38,27.22a17.09,17.09,0,0,1-15.12-2.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,203.24c4.47-7.26,10.06-10.8,13.78-13.77s5-3.17,3.53-4.47-6.32-.56-10.79,3.16a131.25,131.25,0,0,0-9.68,9.31A76.4,76.4,0,0,1,355,185.93a170.27,170.27,0,0,0,8.75-17.68c1.3-3.35-1.3-6-4.47-3.91s-5.95,6.51-7.81,11.35-8.38,16.2-10.24,16.57-1.68-3.73-.75-7.26,4.66-14.33,6.33-18.24,1.86-6.7.19-7.26-6.33,2.6-8.94,10.61-5.46,21.61-5.46,21.61-2.85-8.29-6.85-12.57-8,.5-12.26,5.93,3,6.69,4.29,4.57c2.59-4.42,6.33-8.41,6.7.93.18,4.79.41,14.56-2.16,16.28s-12.57-1.43-12.57-1.43,1.14-3.14,2.29-7.14,2-6.86,0-9.14-4.29,2-4.29,2-7.71,8.28-6.85,13.71,12.28,17.13,15.42,21.42,1.55,17.67,1.55,27.31-2.5,27.85-5,45.7c0,.24-.07.46-.1.69,3.95,4.15,12,10.1,25.61,9.64,9.12-.31,15.58-4.9,19.95-9.95-2.9-8.63-6.54-17-9.24-24-6.05-15.59-9.54-43.93-9.54-43.93a58.05,58.05,0,0,0,5.4-11.36A68.36,68.36,0,0,1,353,203.24Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.62,230.6s-1.67-7.07.75-11.54a12.55,12.55,0,0,1,5.95-5.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished2);
export default __webpack_public_path__ + "static/media/finished-2.85d4844603ee3abe7a84467139cbede1.svg";
export { ForwardRef as ReactComponent };